import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {GAME_STATUSES} from "../../../core/app/consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class TopPerformersWidgetAnalyticsDisplayEvent extends BaseAnalyticsEvent {
  gameId: Number;
  status: GAME_STATUSES;
  sportTypeId: Number;
  type: Number;

  constructor(params) {
    super('', 'display', 'top-performers');

    this.gameId = params.gameId;
    this.status = params.status;
    this.sportTypeId = params.sportTypeId;
    this.type = params.type;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.sportTypeId = this.sportTypeId;


    return properties;
  }
}